<script setup lang="ts">
import { onMounted, ref, type Ref } from 'vue';
import { useLoadingSpinnerStore } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';
import type { Nps } from '@/models/Nps';
import { loadNps } from '@/api/NpsApi';

const { $gettext } = gettext;
const loadingSpinnerStore = useLoadingSpinnerStore();
const nps: Ref<Nps[]> = ref([]);
const error = ref('');

async function getNps() {
  error.value = '';
  loadingSpinnerStore.setShowLoadingOverlay(true);
  try {
    nps.value = await loadNps();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    error.value = err;
  } finally {
    loadingSpinnerStore.setShowLoadingOverlay(false);
  }
}

const headers = [
  { title: $gettext('Score'), value: 'score', sortable: true },
  { title: $gettext('Comment'), value: 'comment', sortable: true },
  { title: $gettext('Created At'), value: 'created_at', sortable: true },
];

onMounted(() => {
  getNps();
});
</script>
<template>
  <div class="pa-4 pa-sm-12">
    <v-row>
      <v-col cols="12">
        <h1>
          {{ $gettext('NPS') }}
          <v-btn
            size="small"
            class="mb-1 ml-4 gradient-oceanblue-whitesands"
            icon="mdi-cached"
            @click="getNps"
          />
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mb-4">
        <v-row v-if="error" class="mt-8">
          <v-col cols="12" md="8" lg="6" xl="4">
            <v-alert
              class="mt-8"
              border="top"
              icon="mdi-close-circle"
              border-color="error"
            >
              {{ error }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table items-per-page="25" :items="nps" :headers="headers">
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
